import {TranslateService} from '@ngx-translate/core';
import {AVAILABLE_APP_LANGUAGES, DEFAULT_APP_LANGUAGE} from './i18n.config';
import {HttpClient} from '@angular/common/http';
import { FrontI18nResource } from './multiTranslateHttpLoader';
import { MultiTranslateHttpLoader } from './multiTranslateHttpLoader';

export function getLocaleId(translateService: TranslateService): string {
    let localeId: string;

    if (AVAILABLE_APP_LANGUAGES.includes(translateService.getBrowserLang())) {
        localeId = translateService.getBrowserCultureLang() || translateService.getBrowserLang();
    } else {
        localeId = DEFAULT_APP_LANGUAGE;
    }

    return localeId;
}

export function createTranslateLoader(httpClient: HttpClient) {
    return new MultiTranslateHttpLoader(httpClient, [
        new FrontI18nResource('./assets/i18n/', '.json', 0),
        new FrontI18nResource('./assets/i18n/theme-labels-', '.json', 1)
    ]);
}
